import { Component, Input, Output, EventEmitter, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ButtonForm } from "../../button-form/button-form";
import { OngetSideBar } from "../../onget-side-bar/onget-side-bar";
import { Modal } from '../../modal/modal';
import { AuthService } from '../../../core/services/auth/auth-service';

@Component({
  selector: 'app-sidebar-manager',
  standalone: true,
  imports: [CommonModule, RouterModule, ButtonForm, OngetSideBar , Modal],
  templateUrl: './sidebar-manager.html',
  styleUrl: './sidebar-manager.css',
})
export class SidebarManager {
  showModal = signal<boolean>(false);

  @Input() isOpen = false;
  @Output() toggleSidebar = new EventEmitter<void>();
  private router = inject(Router);
  private authService = inject(AuthService);
  private breakpointObserver = inject(BreakpointObserver);

  mainMenu = [
    { label: 'Tableau de bord', icon: 'home', route: '/manager/dashboard' },
    { label: 'Clients', icon: 'users', route: '/manager/customers' },
    { label: 'Packs D\'abonnements', icon: 'calendar', route: '/manager/pack-abonnement' },
  ];

  clubMenu = [
    { label: 'Abonnements', icon: 'star', route: '/manager/abonnements' },
    { label: 'Séances', icon: 'star', route: '/manager/seances' },
    { label: 'Employés', icon: 'briefcase', route: '/manager/employees' },
    { label: 'Équipements', icon: 'hammer', route: '/manager/equipments' },
  ];

  toggleModal() {
    this.showModal.set(!this.showModal());
  }

  onItemClick() {
    if (this.breakpointObserver.isMatched([Breakpoints.Handset, '(max-width: 1023.98px)'])) {
      this.toggleSidebar.emit();
    }
  }

  onLogout() {
    this.authService.logout();
  }
}
